import React from "react";

import bgImg from "assets/images/careers/bg_top.png";

import styles from "./index.module.less";


const Header = () => {
  return (
    <div className={styles.careersHeader} style={{ backgroundImage: `url(${bgImg})` }}>
      <div className={styles.picPart}>
        <span>Join Us</span>
        <h5>Join Spikex to acheive a successful career</h5>
        <div className={styles.picPartBg}></div>
      </div>
    </div>
  );
};

export default Header;
